import AppConfig from "../app-config";
import { getDataFromStorage } from "../libs/auth.helper";
export const getOtherUserId = (chat) => {
    const currentUserId = getUserInfo().id;
    return chat.rooms[0].uid === parseInt(currentUserId) ? chat.oid : chat.rooms[0].uid;
};
export const getUserInfo = () => {
    return getDataFromStorage().userInfo;
};
export const isSender = (message) => {
    return message.sender_id === getUserInfo().id;
};
export const isSeller = (message) => {
    return message.oid === getUserInfo().id;
};
export const redirectToOpenSooq = (pid) => {
    const baseLink = process.env.REACT_APP_OPENSOOQ_BASE;
    if (!baseLink)
        return;
    const postLink = generateOpenSooqRedirectUrl(baseLink, AppConfig.getConfig().authenticationData.country, AppConfig.getConfig().lang, pid);
    window.open(postLink, "blank");
};
export const redirectToEditPost = (identifier, pid) => {
    const addPostBaseLink = process.env.REACT_APP_ADD_POST;
    if (!addPostBaseLink)
        return;
    const editPostLink = `${addPostBaseLink}?v=2&source=${AppConfig.getConfig().authenticationData.source}&lang=${AppConfig.getConfig().lang}&flow=edit&draft_id=0&post_id=${pid}&return=${window.location.href}&scrollByIdentifier=${identifier}`;
    window.open(editPostLink, "blank");
};
const generateOpenSooqRedirectUrl = (url, country, lang, pid) => {
    let redirectTo = url === null || url === void 0 ? void 0 : url.replace("{country}", country !== null && country !== void 0 ? country : '').replace("{lang}", lang !== null && lang !== void 0 ? lang : '');
    if (isShobiddak()) {
        redirectTo = url === null || url === void 0 ? void 0 : url.replace("{country}.", '').replace("/{lang}", '');
    }
    return `${redirectTo}/search/${pid}`;
};
const isShobiddak = () => {
    let isShowbidak = false;
    if (getOriginDomain() === process.env.REACT_APP_SHOBIDAK_DOMAIN) {
        isShowbidak = true;
    }
    return isShowbidak;
};
const getOriginDomain = () => {
    var hostname = window.location.hostname; // Get the hostname from the current URL
    var parts = hostname.split('.'); // Split the hostname by periods
    if (parts.length > 2) { // Check if there is a subdomain
        hostname = parts.slice(1).join('.'); // Remove the subdomain
    }
    return hostname;
};
